import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { ADD_SUGGEST_GOLF, ADD_SUGGEST_GOLF_ERROR, ADD_SUGGEST_GOLF_SUCCESS } from '../../../actions.js';

function* addSuggestGolf({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/suggest-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: ADD_SUGGEST_GOLF_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: ADD_SUGGEST_GOLF_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ADD_SUGGEST_GOLF_ERROR, payload: error });
  }
}

export function* watchaddSuggestGolf() {
  yield takeEvery(ADD_SUGGEST_GOLF, addSuggestGolf);
}

function* addSuggestGolfSaga() {
  yield all([fork(watchaddSuggestGolf)]);
}

export default addSuggestGolfSaga;
